<div mat-dialog-title>
  <h1>Checkliste BIOclear</h1>
  <p></p>
</div>
<div mat-dialog-content>
  <app-form-checkliste-lkt-bioclear [form]="form"></app-form-checkliste-lkt-bioclear>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]>Abbrechen</button>
  <button mat-button [mat-dialog-close]="form.dirty ? form.value : null" cdkFocusInitial>
    Speichern
  </button>
</div>
